import { render, staticRenderFns } from "./SideRight.vue?vue&type=template&id=1fd47899&scoped=true&"
import script from "./SideRight.vue?vue&type=script&lang=js&"
export * from "./SideRight.vue?vue&type=script&lang=js&"
import style0 from "./SideRight.vue?vue&type=style&index=0&id=1fd47899&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd47899",
  null
  
)

export default component.exports